import type { LabelHTMLAttributes, PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

export function Label({
  className,
  children,
  ...rest
}: PropsWithChildren<LabelHTMLAttributes<HTMLLabelElement>>) {
  return (
    <label
      className={cn("text-sm font-medium text-slate-700", className)}
      {...rest}
    >
      {children}
    </label>
  );
}
